import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { tap, mergeMap, catchError } from 'rxjs/operators';
// import { AuthResponse, ServerHashParamKeys } from '@azure/msal-browser';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';


@Injectable()
export class RebarInterceptor implements HttpInterceptor {
    public envData: any = null;      
    constructor(public envService: AppConfigService, private injector: Injector, private auth: MsalService, private broadcastService: MsalBroadcastService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.envData = this.envService.getEnvironment();
        if (req.url.includes('identity-management/api/v1/auth/logout')) {
            return next.handle(req);
        }
        if (this.envData == null || this.envData == undefined ||
            (req.url.indexOf(this.envData.api.IOMAPIUrl) == -1)) {
            var jsonReq = req.clone({
                url: req.url,
                //headers: req.headers.set('Content-Type', 'application/json')
            });
            return next.handle(jsonReq);
        }
        else if (req.url.indexOf(this.envData.api.IOMAPIUrl) > -1) {
            let authReq: any = req;
            if (this.envData.AuthProvider == "PAMAuthentication") {
                if (sessionStorage.getItem('IOMToken') != null)
                    authReq = req.clone({
                        setHeaders: {
                            requestverification: sessionStorage.getItem('IOMToken')
                        }
                    })
                return next.handle(authReq);
            }
            else if (this.envData.AuthProvider == "AzureADAuthProvider") {
                if (this.envData.mslConfig.enableMSAL == true) {
                    var tokenRequest = {
                        scopes: []
                    }; 
                    // const scopes = this.auth.instance.getScopesForEndpoint(req.url);
                    // this.auth.getLogger().verbose("Url: " + req.url + " maps to scopes: " + scopes);
                    // console.log("Url: " + req.url + " maps to scopes: " + scopes);
                    // // If there are no scopes set for this request, do nothing.
                    // if (!scopes) {
                    //     return next.handle(req);
                    // }

                    let token: string;
                    // Acquire a token for this request, and attach as proper auth header.
                    return from(
                        this.auth.instance.acquireTokenSilent(tokenRequest)
                        .then((response) => {
                            //   token = response.tokenType === ServerHashParamKeys.ID_TOKEN ? response.idToken.rawIdToken : response.accessToken;
                               token = response.idToken;
                               const authHeader = `Bearer ${token}`;                                   
                               console.log("Token generated sucessfully");                                                        
                               return req.clone({
                                   setHeaders: {
                                       Authorization: authHeader,                                        
                                   }
                               });
                            // .then((response: AuthResponse) => {
                            //     token = response.tokenType === ServerHashParamKeys.ID_TOKEN ? response.idToken.rawIdToken : response.accessToken;
                            //     const authHeader = `Bearer ${token}`;
                            //     return req.clone({
                            //         setHeaders: {
                            //             Authorization: authHeader,
                            //         }
                            //     });
                            }, error => {
                                console.log("Acquire token silentily interceptor failed. Trying again", req);
                                return this.auth.instance.acquireTokenSilent(tokenRequest)
                                // return this.auth.acquireTokenSilent({ scopes, forceRefresh: true })
                                .then((response) => {
                                    //  token = response.tokenType === ServerHashParamKeys.ID_TOKEN ? response.idToken.rawIdToken : response.accessToken;
                                    token = response.idToken;
                                      const authHeader = `Bearer ${token}`;
                                      return req.clone({
                                          setHeaders: {
                                              Authorization: authHeader,
                                          }
                                      })
                                    }, error => {
                                        console.log("Acquire token silentily interceptor failed 2. Trying again", req);
                                        return this.auth.instance.acquireTokenSilent(tokenRequest)
                                        // return this.auth.acquireTokenSilent({ scopes, forceRefresh: true })
                                        .then((response) => {
                                            //   token = response.tokenType === ServerHashParamKeys.ID_TOKEN ? response.idToken.rawIdToken : response.accessToken;
                                            token = response.idToken;
                                               const authHeader = `Bearer ${token}`;
                                               return req.clone({
                                                   setHeaders: {
                                                       Authorization: authHeader,
                                                   }
                                               })
                                            });
                                    });
                            })
                    )
                    .pipe(
                        mergeMap(nextReq => next.handle(nextReq)),
                        tap(
                            () => { },
                            err => {
                                if (err instanceof HttpErrorResponse && err.status === 401) {
                                  //  this.auth.clearCacheForScope(token);
                                   // this.broadcastService.("msal:notAuthorized", err.message);
                                     console.log("Logged: Interceptor : err"); 
                                }
                            }
                        )
                        // .pipe(
                        //     mergeMap(nextReq => next.handle(nextReq)),
                        //     tap(
                        //         () => { },
                        //         err => {
                        //             if (err instanceof HttpErrorResponse && err.status === 401) {
                        //                 this.auth.clearCacheForScope(token);
                        //                 this.broadcastService.broadcast("msal:notAuthorized", err.message);
                        //             }
                        //         }
                        //     )
                        );
                }
            }
            else {
                const userToken = '';
                const modifiedReq = req.clone({
                    headers: req.headers.set('Authorization', `${userToken}`),
                });
                // const modifiedReq = req.clone({

                //     setHeaders: {

                //         Authorization: userToken

                //     }

                // })
                return next.handle(modifiedReq);
            }
        }
    }
}
